import { Permission, Permissions } from "src/app/Constants/Admin/Permissions"

export interface Group {
  ID_G: number,
  Nombre: string,
  Descripcion: string,
  Library_Slug?: string | null,
  Fecha_Creacion: Date | null,
  ID_Creador: number,
  ID_Sharepoint: number,
  Disabled: boolean,
  Administrador: boolean,
  ReadF: boolean,
  Contribuidor: boolean,
  Revisor: boolean,
  Aprobador: boolean,
  DeleteP: boolean,
  HistorialV: boolean,
  Reports: boolean,
  Create_Folder: boolean,
  Approval_Flow: boolean,
  Rename_File: boolean,
  Rename_Folder: boolean,
  Properties: boolean,
  Move_File: boolean,
  Recycle_Bin: boolean,
  Shared_Folder: boolean
}

export interface Group_New_Format {
  ID_G: number,
  Nombre: string,
  Descripcion: string,
  Library_Slug?: string | null,
  Fecha_Creacion: Date | null,
  ID_Creador: number,
  ID_Sharepoint: number,
  Disabled: boolean,
  Permission: Permission[]
}

//Mapea el resultado del endpoint para obtener los todos los grupos a una forma de tipo Group_New_Format
//incluyendo todos sus permisos

export const mapPermissions = (group: Group): Permission[] => {
  const permissions: Permission[] = [];

  if (group.Administrador) permissions.push(Permissions.Administrador);
  if (group.ReadF) permissions.push(Permissions.ReadF);
  if (group.Contribuidor) permissions.push(Permissions.Contribuidor);
  if (group.Aprobador) permissions.push(Permissions.Aprobador);
  if (group.DeleteP) permissions.push(Permissions.DeleteP);
  if (group.HistorialV) permissions.push(Permissions.HistorialV);
  if (group.Reports) permissions.push(Permissions.Reports);
  if (group.Create_Folder) permissions.push(Permissions.Create_Folder);
  if (group.Approval_Flow) permissions.push(Permissions.Approval_Flow);
  if (group.Rename_File) permissions.push(Permissions.Rename_File);
  if (group.Rename_Folder) permissions.push(Permissions.Rename_Folder);
  if (group.Properties) permissions.push(Permissions.Properties);
  if (group.Move_File) permissions.push(Permissions.Move_File);
  if (group.Recycle_Bin) permissions.push(Permissions.Recycle_Bin);
  if (group.Shared_Folder) permissions.push(Permissions.Shared_Folder);

  return permissions;
};

export const mapGroups = (group: Group): Group_New_Format => {
  return {
    ID_G: group.ID_G,
    Nombre: group.Nombre,
    Descripcion: group.Descripcion,
    Library_Slug: group.Library_Slug ?? null,
    Fecha_Creacion: group.Fecha_Creacion,
    ID_Creador: group.ID_Creador,
    ID_Sharepoint: group.ID_Sharepoint,
    Disabled: group.Disabled,
    Permission: mapPermissions(group)
  };
};
